
import './payment.css';
import { useEffect, useState } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "../../components/checkout_form/CheckoutForm";
import { Header } from "../../components/header/Header";
import { backendEnv, endpoints } from '../../env';
import { useServer } from '../../context/serverContext';
import { useBuy } from '../../context/BuyContext';
import { useAuth } from '../../context/AuthContext';

//const stripePromise = loadStripe("pk_test_51OgTpIBh4e0PMVZ9lZkjkjY12oCmxOKx063Nc57QuwEIw2WgjJuguYn29FI8x1nzXqhbms9pNrM1p4Oti5J4dhkr00R14hNUmr");

export default function Payment() {
  const { user }= useAuth();
	const{ token, infoSell, product } = useBuy();
  const {getRequest, postRequest} = useServer();
  const [clientSecret, setClientSecret] = useState('');
  const [stripePromise2, setStripePromise2] = useState('');

  const stripePromise = loadStripe(stripePromise2);

  const appearance = {
    theme: 'stripe',
  };
  const options = {
    clientSecret,
    appearance,
  };
  useEffect(() => {
    console.log("p: ", user);
    getRequest(endpoints.getStripeGateway, {}, (res) => {
      	if (res[0]) {
          	res = res[1];
          	setStripePromise2(res.public);
      	}
  	});
    postRequest(endpoints.getIntentPay, {token: token}, (res) => {
      if (res[0]) {
          res = res[1];
          setClientSecret(res.payIntent.stripe_intent);
      }else{
        setClientSecret(null);
      }
  });
 
  }, []);

  return (<>
    <Header></Header>
    <div className='payment'>

        <div className="App">
          {clientSecret == null && (<p className='txt-not-intent'>No pending charges</p>)}
			
            {clientSecret && (
				<>
				<div className='checkout-info'>
					<p className='title-checkout'>Contact information:</p>
					<p className='name-buy'>{user.name}</p>
				 	<p className='name-buy'>{user.email}</p>
					<br></br>
					<p className='title-checkout'>Academia:</p>
				<span className='ticle-course-buy'>{product.name}</span>
				{infoSell && (
					infoSell.is_sale === 0 ? (
						<span className='price-regular'>${infoSell.price}</span>
					) : (
						<div className='div-sale-price2'>
							<span className='sale-price2'>Price: ${infoSell.sale_price}</span>
							<span className='sale-price2'>+ Tax: ${(infoSell.sale_price * infoSell.tax/100).toFixed(2)}</span>
							<span className='sale-price2'>Total Price: ${(infoSell.sale_price * infoSell.tax/100 + infoSell.sale_price).toFixed(2)}</span>
						</div>
					)
				)}
			 
				</div>
                <Elements options={options} stripe={stripePromise}>
                	<CheckoutForm />
                </Elements>
				</>
            )}

			
        </div>
        
    </div>
    </>
  );
}